var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 58,
    viewBox: "0 0 103 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.0001,
    y: 49,
    width: 6,
    height: 3,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0001,
    y: 55,
    width: 6,
    height: 3,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.00012,
    y: 52,
    width: 21,
    height: 3,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00012207,
    y: 49,
    width: 6,
    height: 3,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00012207,
    y: 55,
    width: 6,
    height: 3,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 78.7453,
    y: 9.85291,
    width: 6,
    height: 3,
    transform: "rotate(-30 78.7453 9.85291)",
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 81.7453,
    y: 15.0491,
    width: 6,
    height: 3,
    transform: "rotate(-30 81.7453 15.0491)",
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6569,
    y: 21.451,
    width: 21,
    height: 3,
    transform: "rotate(-30 64.6569 21.451)",
    fill: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5588,
    y: 20.3529,
    width: 6,
    height: 3,
    transform: "rotate(-30 60.5588 20.3529)",
    fill: "#C4C4C4"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5588,
    y: 25.5491,
    width: 6,
    height: 3,
    transform: "rotate(-30 63.5588 25.5491)",
    fill: "#C4C4C4"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 98.6901,
    y: 33.962,
    width: 6,
    height: 3,
    transform: "rotate(45 98.6901 33.962)",
    fill: "#C4C4C4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 94.4474,
    y: 38.2047,
    width: 6,
    height: 3,
    transform: "rotate(45 94.4474 38.2047)",
    fill: "#C4C4C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 83.8408,
    y: 23.3554,
    width: 21,
    height: 3,
    transform: "rotate(45 83.8408 23.3554)",
    fill: "#C4C4C4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 83.8408,
    y: 19.1128,
    width: 6,
    height: 3,
    transform: "rotate(45 83.8408 19.1128)",
    fill: "#C4C4C4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5981,
    y: 23.3554,
    width: 6,
    height: 3,
    transform: "rotate(45 79.5981 23.3554)",
    fill: "#C4C4C4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 92.0001,
    y: 49,
    width: 6,
    height: 3,
    fill: "#C4C4C4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 92.0001,
    y: 55,
    width: 6,
    height: 3,
    fill: "#C4C4C4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0001,
    y: 52,
    width: 21,
    height: 3,
    fill: "#C4C4C4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 71.0001,
    y: 49,
    width: 6,
    height: 3,
    fill: "#C4C4C4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 71.0001,
    y: 55,
    width: 6,
    height: 3,
    fill: "#C4C4C4"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 68.9092,
    y: 37.0945,
    width: 6,
    height: 3,
    transform: "rotate(15 68.9092 37.0945)",
    fill: "#C4C4C4"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3563,
    y: 42.89,
    width: 6,
    height: 3,
    transform: "rotate(15 67.3563 42.89)",
    fill: "#C4C4C4"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7462,
    y: 35.3335,
    width: 21,
    height: 3,
    transform: "rotate(15 50.7462 35.3335)",
    fill: "#C4C4C4"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 48.6248,
    y: 31.6593,
    width: 6,
    height: 3,
    transform: "rotate(15 48.6248 31.6593)",
    fill: "#C4C4C4"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 47.0719,
    y: 37.4548,
    width: 6,
    height: 3,
    transform: "rotate(15 47.0719 37.4548)",
    fill: "#C4C4C4"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 54.7307,
    y: 43.1933,
    width: 6,
    height: 3,
    transform: "rotate(-15 54.7307 43.1933)",
    fill: "#C4C4C4"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 56.2836,
    y: 48.9889,
    width: 6,
    height: 3,
    transform: "rotate(-15 56.2836 48.9889)",
    fill: "#C4C4C4"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 38.1205,
    y: 50.7498,
    width: 21,
    height: 3,
    transform: "rotate(-15 38.1205 50.7498)",
    fill: "#C4C4C4"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 34.4463,
    y: 48.6285,
    width: 6,
    height: 3,
    transform: "rotate(-15 34.4463 48.6285)",
    fill: "#C4C4C4"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 35.9992,
    y: 54.4241,
    width: 6,
    height: 3,
    transform: "rotate(-15 35.9992 54.4241)",
    fill: "#C4C4C4"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5799,
    y: 35.2122,
    width: 6,
    height: 3,
    transform: "rotate(-15 25.5799 35.2122)",
    fill: "#C4C4C4"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1328,
    y: 41.0078,
    width: 6,
    height: 3,
    transform: "rotate(-15 27.1328 41.0078)",
    fill: "#C4C4C4"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 8.96967,
    y: 42.7687,
    width: 21,
    height: 3,
    transform: "rotate(-15 8.96967 42.7687)",
    fill: "#C4C4C4"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 5.29544,
    y: 40.6474,
    width: 6,
    height: 3,
    transform: "rotate(-15 5.29544 40.6474)",
    fill: "#C4C4C4"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 6.84836,
    y: 46.443,
    width: 6,
    height: 3,
    transform: "rotate(-15 6.84836 46.443)",
    fill: "#C4C4C4"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 41.2453,
    y: 31.3529,
    width: 6,
    height: 3,
    transform: "rotate(30 41.2453 31.3529)",
    fill: "#C4C4C4"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 38.2453,
    y: 36.549,
    width: 6,
    height: 3,
    transform: "rotate(30 38.2453 36.549)",
    fill: "#C4C4C4"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1569,
    y: 24.9509,
    width: 21,
    height: 3,
    transform: "rotate(30 24.1569 24.9509)",
    fill: "#C4C4C4"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0588,
    y: 20.8529,
    width: 6,
    height: 3,
    transform: "rotate(30 23.0588 20.8529)",
    fill: "#C4C4C4"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 20.0588,
    y: 26.049,
    width: 6,
    height: 3,
    transform: "rotate(30 20.0588 26.049)",
    fill: "#C4C4C4"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 76.9092,
    y: 30.0945,
    width: 6,
    height: 3,
    transform: "rotate(15 76.9092 30.0945)",
    fill: "#C4C4C4"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 75.3563,
    y: 35.89,
    width: 6,
    height: 3,
    transform: "rotate(15 75.3563 35.89)",
    fill: "#C4C4C4"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 58.7462,
    y: 28.3335,
    width: 21,
    height: 3,
    transform: "rotate(15 58.7462 28.3335)",
    fill: "#C4C4C4"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 56.6248,
    y: 24.6593,
    width: 6,
    height: 3,
    transform: "rotate(15 56.6248 24.6593)",
    fill: "#C4C4C4"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 55.0719,
    y: 30.4548,
    width: 6,
    height: 3,
    transform: "rotate(15 55.0719 30.4548)",
    fill: "#C4C4C4"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 50.5799,
    y: 14.2122,
    width: 6,
    height: 3,
    transform: "rotate(-15 50.5799 14.2122)",
    fill: "#C4C4C4"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1328,
    y: 20.0078,
    width: 6,
    height: 3,
    transform: "rotate(-15 52.1328 20.0078)",
    fill: "#C4C4C4"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9697,
    y: 21.7687,
    width: 21,
    height: 3,
    transform: "rotate(-15 33.9697 21.7687)",
    fill: "#C4C4C4"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2954,
    y: 19.6474,
    width: 6,
    height: 3,
    transform: "rotate(-15 30.2954 19.6474)",
    fill: "#C4C4C4"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 31.8483,
    y: 25.443,
    width: 6,
    height: 3,
    transform: "rotate(-15 31.8483 25.443)",
    fill: "#C4C4C4"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6139,
    y: 5.43521,
    width: 6,
    height: 3,
    transform: "rotate(15 68.6139 5.43521)",
    fill: "#C4C4C4"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 67.061,
    y: 11.2308,
    width: 6,
    height: 3,
    transform: "rotate(15 67.061 11.2308)",
    fill: "#C4C4C4"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4508,
    y: 3.67422,
    width: 21,
    height: 3,
    transform: "rotate(15 50.4508 3.67422)",
    fill: "#C4C4C4"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 48.3295,
    width: 6,
    height: 3,
    transform: "rotate(15 48.3295 0)",
    fill: "#C4C4C4"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7766,
    y: 5.79556,
    width: 6,
    height: 3,
    transform: "rotate(15 46.7766 5.79556)",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBones);
export default __webpack_public_path__ + "static/media/bones.908f7a82d8632d4160faec0da11d2e95.svg";
export { ForwardRef as ReactComponent };